var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAutoMaterializePolicy = function SvgAutoMaterializePolicy(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8569 3.37221C10.9439 2.6123 9.81224 2.11481 8.5603 2V3.09886C9.50609 3.20273 10.3699 3.57995 11.0806 4.14852L11.8569 3.37221Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46687 3.09886V2C6.21494 2.10934 5.08327 2.6123 4.17029 3.37221L4.9466 4.14852C5.6573 3.57995 6.52109 3.20273 7.46687 3.09886Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17586 4.91938L3.39955 4.14307C2.63964 5.05605 2.14215 6.18771 2.02734 7.43965H3.1262C3.23008 6.49386 3.6073 5.63008 4.17586 4.91938Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9012 7.43965H14.0001C13.8853 6.18771 13.3878 5.05605 12.6279 4.14307L11.8516 4.91938C12.4201 5.63008 12.7973 6.49386 12.9012 7.43965Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28027 7.98629L7.16091 8.83914L8.01376 10.7198L8.86661 8.83914L10.7472 7.98629L8.86661 7.13345L8.01376 5.25281L7.16091 7.13345L5.28027 7.98629Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01367 12.9066C6.31344 12.9066 4.81549 12.0373 3.93531 10.7198H5.28018V9.62638H2V12.9066H3.09339V11.4305C4.18132 12.9831 5.97449 14 8.01367 14C10.6761 14 12.9339 12.2669 13.7212 9.86692L12.6497 9.62091C11.9772 11.5289 10.1567 12.9066 8.01367 12.9066Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAutoMaterializePolicy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/auto-materialize-policy.76a0aa20d7d1694fc479044427ae6739.svg";